import { render, staticRenderFns } from "./TermsModal2.vue?vue&type=template&id=04ce5a8e&"
import script from "./TermsModal2.vue?vue&type=script&lang=ts&"
export * from "./TermsModal2.vue?vue&type=script&lang=ts&"
import style0 from "./TermsModal2.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports